/**
 * История задачи: кто, когда и что поменял.
 *
 * Значения приходят строками ровно в том виде, в каком их записал сервис:
 * имена людей и колонок он подставляет сам, а перечисления (тип, приоритет)
 * остаются машинными — их переводит экран.
 */
import { issueApi } from '@/api'

import type { V1HistoryEntry } from '@/api/clients/tracker-issue'

/** Столько записей берём за раз: история длинная, а читают её сверху */
export const HISTORY_PER_PAGE = 30

export interface HistoryEntry {
  id: string
  actorName: string
  field: string
  oldValue: string
  newValue: string
  createdAt: string
}

const toEntry = (entry: V1HistoryEntry): HistoryEntry => ({
  // Идентификатор записи в protobuf — int64, то есть строка в JSON.
  id: String(entry.id ?? ''),
  actorName: entry.actorName ?? '',
  field: entry.field ?? '',
  oldValue: entry.oldValue ?? '',
  newValue: entry.newValue ?? '',
  createdAt: entry.createdAt ?? '',
})

export interface HistoryPage {
  entries: HistoryEntry[]
  total: number
}

export const listHistory = async (issueId: string, page = 1): Promise<HistoryPage> => {
  const { data } = await issueApi.issueServiceListIssueHistory(
    issueId,
    String(page),
    String(HISTORY_PER_PAGE),
  )

  return {
    entries: (data.entries ?? []).map(toEntry),
    total: Number(data.pageInfo?.total ?? 0),
  }
}
